// extracted by mini-css-extract-plugin
export default {"page":"v2-z","cartModal":"w2-z","checkout":"x2-z","placeholder":"y2-z","account":"z2-z"};